import React from "react";
import { useTranslation } from "react-i18next";
import "./WhatsAppContact.scss";

import whatsappQR from "../../assets/whatapp.webp";

const WHATSAPP_NUMBER = "495217708288";
const WHATSAPP_URL = `https://wa.me/${WHATSAPP_NUMBER}`;

export default function WhatsAppContact() {
  const { t } = useTranslation();

  return (
    
<section className="whatsapp-contact">
  {/* Отдельный блок с QR-кодом */}
  <div className="whatsapp-contact__qr">
    <img
      src={whatsappQR}
      alt={t("whatsapp.qrAlt")}
    />
  </div>

  {/* Отдельный блок с текстом */}
  <div className="whatsapp-contact__content">
    <h2>{t("whatsapp.title")}</h2>

    <p>{t("whatsapp.description")}</p>

    <p>{t("whatsapp.instruction")}</p>

    <a
      className="whatsapp-contact__button"
      href={WHATSAPP_URL}
      target="_blank"
      rel="noopener noreferrer"
    >
      {t("whatsapp.button")}
    </a>

    <a
      className="whatsapp-contact__phone"
      href={WHATSAPP_URL}
      target="_blank"
      rel="noopener noreferrer"
    >
      +49 521 7708288
    </a>
  </div>
</section>

  );
}
